@if (isMobile()) {
	<cramo-menu-mobile />
} @else {
	<cramo-menu-desktop />
}
